// extracted by mini-css-extract-plugin
export default {"input":"Input_input__295Ru","invalid":"Input_invalid__J3obv","invalid_text":"Input_invalid_text__TIvw3"};